<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <el-row class="cs-titleContainer">
              <el-col :span="16">
                <span class="cs-title">校区成绩搜集</span>
              </el-col>
            </el-row>
            <div class="cs-search-conditions margin-top-10">
              <div class="hidden-xs-only">
                <el-row :gutter="16" v-loading="isConditionLoading">
                  <!-- <el-col :span="4">
                  <el-select placeholder="课程类型" size="medium" :disabled="loading" v-model="searchCondition.courseType" @change="onCourseTypeChange">
                    <el-option v-for="item in courseTypeItems" :key="item.value" :label="item.desc" :value="item.value" />
                  </el-select>
                </el-col> -->
                  <div class="cs-content-group" v-if="searchCondition.courseType === GLOBAL.courseType.university">
                    <el-col :span="4">
                      <el-select placeholder="学期" size="medium" :disabled="loading" v-model="searchCondition.termId" @change="onTermIdChange">
                        <el-option v-for="item in termList" :key="item.Id" :label="item.DisplayLable" :value="item.Id" />
                      </el-select>
                    </el-col>
                    <el-col :span="4">
                      <el-select placeholder="学校" size="medium" :disabled="loading" v-model="searchCondition.groupNumber" @change="onGroupNumberChange">
                        <el-option v-for="item in universityGroups" :key="item.IdValue" :label="item.NameValue" :value="item.GroupNumber" />
                      </el-select>
                    </el-col>
                  </div>
                  <div class="cs-content-group" v-if="searchCondition.courseType === GLOBAL.courseType.vocationalTraining">
                    <el-col :span="4">
                      <el-select placeholder="职业类型" size="medium" :disabled="loading" v-model="searchCondition.trainingCourseCategory"
                        @change="onTrainingCourseCategoryChange">
                        <el-option v-for="item in trainingCourseCategories" :key="item.Id" :label="item.Name" :value="item.Id" />
                      </el-select>
                    </el-col>
                    <el-col :span="4">
                      <el-select placeholder="学期" size="medium" :disabled="loading" v-model="searchCondition.trainingTermId" @change="onTrainingTermIdChange">
                        <el-option v-for="item in trainingTermList" :key="item.Id" :label="item.DisplayLable" :value="item.Id" />
                      </el-select>
                    </el-col>
                  </div>
                  <el-col v-if="!USERMANAGER.isTeacher" :span="4">
                    <el-select placeholder="老师" size="medium" :disabled="loading" filterable v-model="searchCondition.teacherId" @change="onTeacherIdChange">
                      <el-option label="所有老师" :value="0" />
                      <el-option v-for="item in termTeacherList" :key="item.Id" :label="item.Name" :value="item.Id" />
                    </el-select>
                  </el-col>
                  <el-col :span="4">
                    <el-select placeholder="课程" size="medium" :disabled="loading" filterable v-model="searchCondition.courseId" @change="onCourseIdChange">
                      <!-- <el-option v-if="!USERMANAGER.isTeacher" label="所有课程" :value="0" :disabled="!this.searchCondition.teacherId" /> -->
                      <el-option v-if="!USERMANAGER.isTeacher" label="所有课程" :value="0" />
                      <el-option v-for="item in filteredCourseList" :key="item.Id" :label="item.Name" :value="item.Id" />
                    </el-select>
                  </el-col>
                  <el-col v-if="searchCondition.courseType === GLOBAL.courseType.vocationalTraining" :span="4">
                    <el-select placeholder="校区" size="medium" :disabled="loading" filterable v-model="searchCondition.campusId" @change="onCampusIdChange">
                      <el-option :key="0" label="所有校区" :value="0" />
                      <el-option v-for="item in courseCampusList" :key="item.Id" :label="item.Name" :value="item.Id" />
                    </el-select>
                  </el-col>
                  <el-col :span="USERMANAGER.isTeacher ? 12 : 8" class="cs-buttons right">
                    <el-button type="primary" :disabled="loading" size="medium" @click="onSearch">搜索</el-button>
                    <el-button type="primary" :disabled="loading || isExporting" size="medium" @click="onExport" :loading="isExporting">导出</el-button>
                    <el-button v-if="canDownloadScoreAttachments" type="primary" :disabled="loading || isDownloadingAttachments" size="medium" @click="onDownloadScoreAttachments" :loading="isDownloadingAttachments">下载成绩图片</el-button>
                  </el-col>
                </el-row>
                <el-row :gutter="16">
                  <el-col :span="18" class="cs-editor">
                    <div v-if="!isReadonly && isScoreEditing" class="cs-studentScoreCollection-editor-item">
                      <span>期中考试日期：</span>
                      <el-date-picker size="medium" placeholder="期中考试日期" :clearable="false" :disabled="loading" v-model="searchCondition.midtermExamDate" />
                      <el-tooltip placement="top">
                        <div slot="content">
                          同步给所有学生<br/>如时间不同，需自行修改
                        </div>
                        <el-button :disabled="loading" size="medium" icon="el-icon-edit" circle @click="onMidtermExamDateSave" />
                      </el-tooltip>
                    </div>
                    <div class="cs-studentScoreCollection-editor-item" v-if="!isReadonly && isScoreEditing">
                      <span>期中平均分：</span>
                      <el-input :disabled="loading" v-model="searchCondition.midtermAverageScore" size="medium" placeholder="期中平均分"
                        oninput="value=value.replace(/[^0-9.]/g,'')" onblur="value=!!value?value.toNumber().toFixedEx(2):null" />
                       <el-tooltip placement="top">
                        <div slot="content">
                         同步给所有学生<br/>如均分不同，需自行修改
                        </div>
                        <el-button :disabled="loading" size="medium" icon="el-icon-edit" circle @click="onMidtermAverageScoreSave" />
                      </el-tooltip>
                    </div>
                  </el-col>
                  <el-col :span="6" class="cs-editor right">
                    <div v-if="!isReadonly">
                      <div v-if="isScoreEditing">
                        <el-button type="primary" :disabled="loading" size="medium" style="margin-left: 10px;" @click="onSave">保存</el-button>
                        <el-button type="primary" :disabled="loading" size="medium" @click="onCancel">取消</el-button>
                      </div>
                      <div v-else>
                        <el-button type="primary" :disabled="loading" size="medium" @click="onEdit">编辑成绩</el-button>
                      </div>
                    </div>
                    <div v-else class="cs-empty">&nbsp;</div>
                    <span v-if="isConditionChange">(搜索条件已改变，请点击搜索按钮刷新数据后再进行编辑)</span>
                    <span v-if="showLockedLabel && isLocked && !isConditionChange && !loading">(成绩已锁定)</span>
                  </el-col>
                </el-row>
              </div>
              <div class="shown-xs-only">
                <el-row :gutter="8" v-loading="isConditionLoading">
                  <div class="cs-content-group" v-if="searchCondition.courseType === GLOBAL.courseType.university">
                    <el-col :span="4" :xs="8">
                      <el-select placeholder="学期" size="mini" :disabled="loading" v-model="searchCondition.termId" @change="onTermIdChange">
                        <el-option v-for="item in termList" :key="item.Id" :label="item.DisplayLable" :value="item.Id" />
                      </el-select>
                    </el-col>
                    <el-col :span="4" :xs="8">
                      <el-select placeholder="学校" size="mini" :disabled="loading" v-model="searchCondition.groupNumber" @change="onGroupNumberChange">
                        <el-option v-for="item in universityGroups" :key="item.IdValue" :label="item.NameValue" :value="item.GroupNumber" />
                      </el-select>
                    </el-col>
                  </div>
                  <div class="cs-content-group" v-if="searchCondition.courseType === GLOBAL.courseType.vocationalTraining">
                    <el-col :span="4" :xs="8">
                      <el-select placeholder="职业类型" size="mini" :disabled="loading" v-model="searchCondition.trainingCourseCategory"
                        @change="onTrainingCourseCategoryChange">
                        <el-option v-for="item in trainingCourseCategories" :key="item.Id" :label="item.Name" :value="item.Id" />
                      </el-select>
                    </el-col>
                    <el-col :span="4" :xs="8">
                      <el-select placeholder="学期" size="mini" :disabled="loading" v-model="searchCondition.trainingTermId" @change="onTrainingTermIdChange">
                        <el-option v-for="item in trainingTermList" :key="item.Id" :label="item.DisplayLable" :value="item.Id" />
                      </el-select>
                    </el-col>
                  </div>
                  <el-col v-if="!USERMANAGER.isTeacher" :span="4" :xs="8">
                    <el-select placeholder="老师" size="mini" :disabled="loading" filterable v-model="searchCondition.teacherId" @change="onTeacherIdChange">
                      <el-option label="所有老师" :value="0" />
                      <el-option v-for="item in termTeacherList" :key="item.Id" :label="item.Name" :value="item.Id" />
                    </el-select>
                  </el-col>
                  <el-col :span="4" :xs="8">
                    <el-select placeholder="课程" size="mini" :disabled="loading" filterable v-model="searchCondition.courseId" @change="onCourseIdChange">
                      <el-option v-if="!USERMANAGER.isTeacher" label="所有课程" :value="0" />
                      <el-option v-for="item in filteredCourseList" :key="item.Id" :label="item.Name" :value="item.Id" />
                    </el-select>
                  </el-col>
                  <el-col v-if="searchCondition.courseType === GLOBAL.courseType.vocationalTraining" :span="4" :xs="8">
                    <el-select placeholder="校区" size="mini" :disabled="loading" filterable v-model="searchCondition.campusId" @change="onCampusIdChange">
                      <el-option :key="0" label="所有校区" :value="0" />
                      <el-option v-for="item in courseCampusList" :key="item.Id" :label="item.Name" :value="item.Id" />
                    </el-select>
                  </el-col>
                  <el-col :span="4" :xs="8">
                    <el-select placeholder="显示列类型" size="mini" :disabled="loading" v-model="searchCondition.examType" @change="onExamTypeChange">
                      <el-option v-for="(item, index) in examTypeList" :key="index" :label="item.label" :value="item.value" />
                    </el-select>
                  </el-col>
                </el-row>
                <el-row :gutter="8">
                  <el-col v-if="isScoreEditing" :span="10" class="cs-editor">
                    <div v-if="!isReadonly" class="cs-content-group">
                      <span>期中考试日期：</span>
                      <el-date-picker size="mini" placeholder="期中考试日期" :clearable="false" :disabled="loading" v-model="searchCondition.midtermExamDate" />
                      <el-tooltip placement="top">
                        <div slot="content">同步给所有学生</div>
                        <el-button :disabled="loading" size="mini" icon="el-icon-edit" title="应用" circle @click="onMidtermExamDateSave" />
                      </el-tooltip>
                    </div>
                  </el-col>
                  <el-col v-if="isScoreEditing" :span="9" class="cs-editor">
                    <div v-if="!isReadonly" v-show="isScoreEditing" class="cs-content-group">
                      <span>期中平均分：</span>
                      <el-input :disabled="loading" v-model="searchCondition.midtermAverageScore" size="mini" placeholder="期中平均分"
                        oninput="value=value.replace(/[^0-9.]/g,'')" onblur="value=!!value?value.toNumber().toFixedEx(2):null" />
                      <el-button :disabled="loading" size="mini" icon="el-icon-edit" title="应用" circle @click="onMidtermAverageScoreSave" />
                    </div>
                    <div v-else class="cs-empty">&nbsp;</div>
                  </el-col>
                  <el-col v-if="!isScoreEditing" :span="14" class="cs-buttons right">
                    <div>
                      <el-button type="primary" :disabled="loading" size="mini" @click="onEdit">编辑成绩</el-button>
                      <el-button type="primary" :disabled="loading" size="mini" @click="onSearch(1)">搜索</el-button>
                      <el-button type="primary" :disabled="loading || isExporting" size="mini" @click="onExport" :loading="isExporting">导出</el-button>
                      <el-button v-if="canDownloadScoreAttachments" type="primary" :disabled="loading || isDownloadingAttachments" size="mini" @click="onDownloadScoreAttachments" :loading="isDownloadingAttachments">下载成绩图片</el-button>
                    </div>
                  </el-col>
                  <el-col v-else :span="5" class="cs-editor right">
                    <div v-if="!isReadonly" v-show="isScoreEditing">
                      <el-button type="primary" :disabled="loading" size="mini" @click="onSave">保存</el-button>
                      <el-button type="primary" :disabled="loading" size="mini" @click="onCancel">取消</el-button>
                    </div>
                    <div v-else class="cs-empty">&nbsp;</div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24" class="cs-editor right">
                    <span v-if="isConditionChange">(搜索条件已改变，请点击搜索按钮刷新数据后再进行编辑)</span>
                    <span v-if="showLockedLabel && isLocked && !isConditionChange && !loading">(成绩已锁定)</span>
                  </el-col>
                </el-row>
              </div>
            </div>

            <pagination class="cs-table" v-loading="loading" :maxHeight="650" :data="signInListData" :option="paginationOption">
              <template #YearCourseType="{row}">
                <span>{{GLOBAL.enumYearCourseType.getDesc(row.YearCourseType)}}</span>
              </template>
              <template #MidtermExamDateText="{row}">
                <span v-if="!isScoreEditing" :class="{'french-grey': !row.MidtermExamDate}">{{row.MidtermExamDateText}}</span>
                <el-date-picker v-else size="small" type="date" placeholder="期中考试日期" v-model="row.MidtermExamDate"
                  value-format="yyyy-MM-dd" :clearable="true" />
              </template>
              <template #MidtermAverageScore="{row}">
                <span v-if="!isScoreEditing" :class="getScoreClass(row.MidtermAverageScore)">{{getScoreText(row.MidtermAverageScore)}}</span>
                <el-input v-else size="small" placeholder="期中平均分" v-model="row.MidtermAverageScore" oninput="value=value.replace(/[^0-9.]/g,'')"
                  onblur="value=!!value?value.toNumber().toFixedEx(2):null" />
              </template>
              <template #MidtermScore="{row}">
                <span v-if="!isScoreEditing" :class="getScoreClass(row.MidtermScore)">{{getScoreText(row.MidtermScore)}}</span>
                <el-input v-else size="small" placeholder="期中成绩" v-model="row.MidtermScore" oninput="value=value.replace(/[^0-9.]/g,'')"
                  onblur="value=!!value?value.toNumber().toFixedEx(2):null" />
              </template>
              <template #CourseScoreId="{row}">
                <span v-if="!isScoreEditing" :class="{'french-grey': !getCourseScoreItem(row.CourseScoreId)}">{{getCourseScoreText(row.CourseScoreId)}}</span>
                <div v-else>
                  <el-select v-if="signInListData.AdditionalResult.CourseType === GLOBAL.courseType.vocationalTraining" placeholder="期末成绩"
                    v-model="row.CourseScoreId" size="small">
                    <el-option v-for="item in trainingScoreList" :key="item.Value" :label="item.Text" :value="`${item.Value}`.toNumber()" />
                  </el-select>
                  <el-select v-else placeholder="期末成绩" v-model="row.CourseScoreId" size="small" clearable>
                    <el-option v-for="item in scoreList" :key="item.Value" :label="item.Text" :value="`${item.Value}`.toNumber()" />
                  </el-select>
                </div>
              </template>
              <template #ScoreComment="{row}">
                <span v-if="!isScoreEditing">{{row.ScoreComment}}</span>
                <el-input v-else size="small" placeholder="期中备注" maxlength="500" v-model="row.ScoreComment" />
              </template>
              <template #TermEndScoreComment="{row}">
                <span v-if="!isScoreEditing">{{row.TermEndScoreComment}}</span>
                <el-input v-else size="small" placeholder="期末备注" maxlength="500" v-model="row.TermEndScoreComment" />
              </template>
              <template #Attachments="{row}">
                <el-button v-if="isScoreEditing" type="text" size="medium" @click="openAttachmentsUploader(row)">点击上传</el-button>
                <div v-for="(item, index) in row.Attachments" :key="index">
                  <el-button :loading="item.__isDownloading" type="text" size="medium" @click="downloadAttachment(item)">{{item.FileName}}</el-button>
                  <el-button v-if="isScoreEditing" type="text" @click="deleteAttachment(item, row)">
                    <i class="el-icon el-icon-close delete-row-icon" />
                  </el-button>
                </div>
              </template>
            </pagination>
            <div class="cs-studentScoreCollection-info">
              <span>考核缺勤率: 以第一节课日期为基准进行计算</span>
              <span>实际出勤率: 以学生报名日期为基准进行计算</span>
              <span>教务部计算成绩考核以考核缺勤率为准，学生晚报名前没上的课也算缺勤；实际出勤率表述了学生报名后的真实出勤率。</span>
            </div>
            <template>
              <el-dialog center title="上传附件" :show-close="true" :close-on-click-modal="false" width="700px" :visible.sync="attachmentsUploaderVisible" top="8vh"
                z-index="2000">
                <blobUploader :type="3" :accepts="'.png,.jpg,.jpeg'" :isMulti="true" :isAutoSave="true" :isVisible="attachmentsUploaderVisible"
                  @closeEditor="onCloseAttachmentsUploader" @blobUploadError="onAttachmentsUploadError" @blobUploaded="onAttachmentsUploaded" />
              </el-dialog>
            </template>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ObjectEx } from "vue-objectex";
import {
  getBlobFileUrlById,
  downloadFileToBlob,
} from "@/service/blobStorage.service";
import { formatDate, downloadFile } from "@/config/mUtils";
import blobUploader from "@/components/fileHandler/blobUploader";
import imageShow from "@/components/fileHandler/imageShow";
import { mixinDevice } from "@/core/mixin";

import {
  getScoreList,
  getUniversityGroups,
  getTerms,
  getTrainingCategoryList,
  getTrainingTerms,
  getCourseCampusList,
  getTermTeachers,
} from "@/service/common.service";
import { getCoursesInTerm } from "@/service/speedupCourse.service";
import { getWeekList } from "@/service/termManage.service";
import {
  getStudentScoreCollectionPageData,
  exportStudentScore,
  downloadStudentScoreAttachments,
  getUniversityScoreLocks,
} from "@/service/signInManage.service";
import { saveStudentSpeedupCoursesScore } from "@/service/student.service";

const moment = require("moment");

const defaultValues = {
  signInListData: {
    Columns: [],
    Results: [],
    AdditionalResult: {},
  },
};

const enumExamType = new ObjectEx(
  [
    {
      key: "Midterm",
      value: 1,
      desc: "期中",
    },
    {
      key: "Terminal",
      value: 2,
      desc: "期末",
    },
  ],
  {},
  {
    selectListItems: {
      get() {
        let options = this.getOptions();

        return options.map((item) => ({
          value: item.value,
          label: item.desc,
        }));
      },
    },
  }
);

const mixin_tableMethods = {
  data() {
    return {
      attachmentsUploaderVisible: false,
      currentUploadRow: null,
    };
  },
  components: {
    blobUploader,
    imageShow,
  },
  methods: {
    getScoreClass(score) {
      return { "french-grey": !score && score !== 0 };
    },
    getScoreText(score) {
      return !!score || score === 0 ? score : "未录入";
    },
    getCourseScoreItem(courseScoreId) {
      let scoreItem = null;

      if (
        this.signInListData.AdditionalResult.CourseType ===
        this.GLOBAL.courseType.vocationalTraining
      ) {
        scoreItem = this.trainingScoreList.find(
          (item) => item.Value == courseScoreId
        );
      } else {
        scoreItem = this.scoreList.find((item) => item.Value == courseScoreId);
      }

      return scoreItem;
    },
    getCourseScoreText(courseScoreId) {
      let scoreItem = this.getCourseScoreItem(courseScoreId);

      return !!scoreItem ? scoreItem.Text : "未录入";
    },
    getChangedScoreDataList(checkInvalidStudents) {
      let invalidStudents = [];
      let dataList = [];
      this.signInListData.Results.forEach((item) => {
        let oItem = this.originalSignInListData.Results.find(
          (x) => x.StudentSpeedupCourseId === item.StudentSpeedupCourseId
        );

        let newMidtermExamDate = item.MidtermExamDate || null;
        let newMidtermAverageScore = item.MidtermAverageScore || null;
        let newMidtermScore = item.MidtermScore || null;
        let newCourseScoreId = item.CourseScoreId || null;
        let newScoreComment = item.ScoreComment || null;
        let newTermEndScoreComment = item.TermEndScoreComment || null;
        let newAttachmentFieldIds = item.Attachments.map((x) => x.FileId);

        if ((newMidtermAverageScore || newMidtermScore) && !newMidtermExamDate) {
          invalidStudents.push(item.StudentName);
        }

        let oldMidtermExamDate = (oItem && oItem.MidtermExamDate) ? moment(oItem.MidtermExamDate).format("YYYY-MM-DD") : null;
        let oldMidtermAverageScore = oItem.MidtermAverageScore || null;
        let oldMidtermScore = oItem.MidtermScore || null;
        let oldCourseScoreId = oItem.CourseScoreId || null;
        let oldScoreComment = oItem.ScoreComment || null;
        let oldTermEndScoreComment = oItem.TermEndScoreComment || null;
        let oldAttachmentFieldIds = oItem.Attachments.map((x) => x.FileId);
        let newMidtermExamDateStr = newMidtermExamDate ? moment(newMidtermExamDate).format("YYYY-MM-DD") : null;
        if (!!newMidtermAverageScore)
          newMidtermAverageScore = `${newMidtermAverageScore}`
            .toNumber()
            .toFixedEx(2);
        if (!!newMidtermScore)
          newMidtermScore = `${newMidtermScore}`.toNumber().toFixedEx(2);
        let isAttachmentChanged =
          newAttachmentFieldIds.length !== oldAttachmentFieldIds.length ||
          newAttachmentFieldIds.some(
            (x) => !oldAttachmentFieldIds.contains(x)
          ) ||
          oldAttachmentFieldIds.some((x) => !newAttachmentFieldIds.contains(x));

        if (
          newMidtermExamDateStr != oldMidtermExamDate ||
          newMidtermAverageScore != oldMidtermAverageScore ||
          newMidtermScore != oldMidtermScore ||
          newCourseScoreId != oldCourseScoreId ||
          newScoreComment != oldScoreComment ||
          newTermEndScoreComment != oldTermEndScoreComment ||
          isAttachmentChanged
        ) {
          dataList.push({
            Id: item.StudentSpeedupCourseId,
            MidtermExamDate: newMidtermExamDateStr,
            MidtermAverageScore: newMidtermAverageScore,
            MidtermScore: newMidtermScore,
            CourseScoreId: newCourseScoreId,
            ScoreComment: newScoreComment,
            TermEndScoreComment: newTermEndScoreComment,
            Attachments: item.Attachments.map((x) => ({
              StudentSpeedupCourseId: x.StudentSpeedupCourseId,
              FileId: x.FileId,
              FileName: x.FileName,
              PictureUrl: x.PictureUrl,
            })),
          });

          if (item.MidtermAverageScore != newMidtermAverageScore)
            item.MidtermAverageScore = newMidtermAverageScore;
          if (item.MidtermScore != newMidtermScore)
            item.MidtermScore = newMidtermScore;
          if (item.ScoreComment != newScoreComment)
            item.ScoreComment = newScoreComment;
          if (item.TermEndScoreComment != newTermEndScoreComment)
            item.TermEndScoreComment = newTermEndScoreComment;
        }
      });
      if (checkInvalidStudents && invalidStudents.length > 0) {
        let msg = "有学生填写了期中成绩但未填写期中考试日期，请先填写："
          + invalidStudents.join("、");
        this.$message.error(msg);
        return null;
      }
      return dataList;
    },
    openAttachmentsUploader(row) {
      this.currentUploadRow = row;
      this.attachmentsUploaderVisible = true;
    },
    closAttachmentsUploader() {
      this.attachmentsUploaderVisible = false;
      this.currentUploadRow = null;
    },
    onCloseAttachmentsUploader() {
      this.closAttachmentsUploader();
    },
    onAttachmentsUploadError() {},
    onAttachmentsUploaded(data) {
      if (!!data && data.length > 0) {
        if (!!this.currentUploadRow) {
          data.forEach((item) => {
            this.currentUploadRow.Attachments.push({
              StudentSpeedupCourseId:
                this.currentUploadRow.StudentSpeedupCourseId,
              FileId: item.FileId,
              FileName: item.FileName,
              PictureUrl: item.Path,
            });
          });
        }

        this.closAttachmentsUploader();
      }
    },
    downloadAttachment(item) {
      this.$set(item, "__isDownloading", true);

      let fileId = item.FileId;
      getBlobFileUrlById(fileId)
        .then((result) => {
          if (!!result && result.success) {
            let { Url, FileName } = result.data;

            downloadFileToBlob(Url, 0)
              .then((res) => {
                downloadFile({ data: res.data, filename: FileName }, true);
                this.$set(item, "__isDownloading", false);
              })
              .catch((err) => {
                this.$message.error(err.message);
                this.$set(item, "__isDownloading", false);
              });
          } else {
            if (!!result.message) {
              this.$message.error(result.message);
            }
            this.$set(item, "__isDownloading", false);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
          this.$set(item, "__isDownloading", false);
        });
    },
    deleteAttachment(item, row) {
      this.$confirm("您确定要删除该附件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          row.Attachments.remove(item);
        })
        .catch(() => {});
    },
  },
};

export default {
  name: "studentScoreCollection",
  mixins: [mixinDevice, mixin_tableMethods],
  components: {
    navigator: () => import("@/components/navigator"),
    pagination: () => import("@/components/common/pagination"),
  },
  data() {
    let enumScoreField = new ObjectEx([
      {
        key: "MidtermAverageScore",
        value: "MidtermAverageScore",
      },
      {
        key: "MidtermScore",
        value: "MidtermScore",
      },
      {
        key: "CourseScoreId",
        value: "CourseScoreId",
      },
    ]);

    return {
      isScoreEditing: false,
      isExporting: false,
      isDownloadingAttachments: false,
      loading: false,
      isConditionLoading: false,
      isLocked: true,
      showLockedLabel: false,
      isConditionChange: false,
      scoreLocks: null,
      enumScoreField,
      examTypeList: enumExamType.selectListItems,
      searchCondition: {
        courseType: 1,
        groupNumber: null,
        termId: null,
        trainingCourseCategory: null,
        trainingTermId: null,
        teacherId: null,
        courseId: null,
        campusId: null,
        week: null,
        isVideoCourseRemoved: false,
        isYearCourseMerged: false,
        searchDate: "",
        midtermExamDate: null,
        midtermAverageScore: null,
        viewMode: 0, //desktop: 0, mobile: 1
        examType: enumExamType.Midterm,
      },
      previousCourseId: null,
      courseTypeItems: [],
      universityGroups: [],
      termList: [],
      trainingCourseCategories: [],
      trainingTermList: [],
      termTeacherList: [],
      allTermsCourseList: {},
      courseList: [],
      courseCampusList: [],
      weekList: [],
      scoreList: [],
      trainingScoreList: [],
      pickerOptions: {
        firstDayOfWeek: 1,
      },
      paginationOption: {
        displayPagination: false,
        hasEditButton: false,
        editButtonText: String.empty,
        hasAddButton: false,
        addButtonText: String.empty,
        hasSearch: false,
        editColumnTite: String.empty,
        showAcitveColor: true,
        hideDisableRow: true,
        showTotalMinutes: !this.USERMANAGER.isTeacher,
        showSpecialCols: true,
        showMidtermCols: true,
        showTerminalCols: true,
        showRealAttendance: true,
        fnCustomColumnClass: (col, colIndex) => {
          let classList = [];

          switch (col.Field) {
            case "TotalMinutes":
            case "MidtermTotalMinutes":
            case "MidtermExamDateText":
            case "MidtermAbsentPercentage":
            case "MidtermActualAttendancePercentage":
            case "MidtermRealAttendancePercentage":
            case "AbsentPercentage":
            case "ActualAttendancePercentage":
            case "RealAttendancePercentage":
            case "MidtermAverageScore":
            case "MidtermScore":
            case "CourseScoreId":
            case "ScoreComment":
            case "TermEndScoreComment":
              classList.push("hidden-xs-only");
              break;
          }

          switch (col.Field) {
            case "MidtermExamDateText":
            case "MidtermAbsentPercentage":
            case "MidtermAverageScore":
            case "MidtermScore":
            case "ScoreComment":
              if (this.searchCondition.examType === enumExamType.Midterm)
                classList.push("shown-midterm");
              break;
            case "AbsentPercentage":
            case "CourseScoreId":
            case "TermEndScoreComment":
              if (this.searchCondition.examType === enumExamType.Terminal)
                classList.push("shown-terminal");
              break;
          }

          return classList.join(" ");
        },
      },
      signInListData: Object.clone(defaultValues.signInListData),
      originalSignInListData: Object.clone(defaultValues.signInListData),
    };
  },
  created() {
    this.reloadSearchConditionsAndListData();
  },
  computed: {
    canDownloadScoreAttachments() {
      return this.USERMANAGER.isAdmin || this.USERMANAGER.isAcademicAffairs;
    },
    isReadonly() {
      return (
        this.isConditionChange ||
        this.isLocked ||
        !(
          this.USERMANAGER.isAdmin ||
          this.USERMANAGER.isTeacher ||
          this.USERMANAGER.isAcademicDirector ||
          this.USERMANAGER.isEducationalAssistant
        )
      );
    },
    showIsYearCourseMerged() {
      let courseType = this.signInListData.AdditionalResult.CourseType;
      let termId = this.signInListData.AdditionalResult.TermId;
      let courseId = this.signInListData.AdditionalResult.CourseId;

      if (courseType !== this.GLOBAL.courseType.university) return false;

      let course = this.courseList.find((item) => item.Id === courseId);
      if (!course || !course.IsYearCourse) return false;

      let term = this.termList.find((item) => item.Id === termId);
      if (!term) return false;

      let termStartMonth = getDatePart(term.StartDate, "month");
      let termEndMonth = getDatePart(term.EndDate, "month");
      if (
        (termStartMonth == course.StartMonth &&
          termEndMonth === course.EndMonth) ||
        termEndMonth !== course.EndMonth
      )
        return false;

      return true;
    },
    filteredCourseList() {
      let data = this.courseList.filter(
        (course) =>
          !this.searchCondition.teacherId ||
          course.TeacherIds.contains(this.searchCondition.teacherId)
      );

      return data;
    },
  },
  methods: {
    async loadUniversityScoreLocksFromServer() {
      try {
        let result = await getUniversityScoreLocks(this.searchCondition.termId);
        this.scoreLocks = !!result && result.success ? result.data : [];
      } catch (error) {
        console.error(error);
      }
    },
    async loadScoreListFromServer() {
      try {
        let result = await getScoreList();
        let scoreList = !!result && result.success ? result.data : [];
        this.scoreList = scoreList.filter(
          (i) => i.CourseType == this.GLOBAL.courseType.university
        );
        this.trainingScoreList = scoreList.filter(
          (i) => i.CourseType == this.GLOBAL.courseType.vocationalTraining
        );
      } catch (error) {
        console.error(error);
      }
    },
    async loadTermsFromServer() {
      try {
        let result = await getTerms(false, true);
        this.termList = !!result && result.success ? result.data : [];
        let currentTerm = null;
        if (this.termList.length > 0) {
          currentTerm = this.termList.find((i) => i.IsCurrentTerm);
          if (!currentTerm) currentTerm = this.termList[0];
        }
        this.searchCondition.termId = !!currentTerm ? currentTerm.Id : null;
      } catch (error) {
        console.error(error);
      }
    },
    async loadUniversityGroupsFromServer() {
      try {
        let result = await getUniversityGroups(
          undefined,
          undefined,
          this.searchCondition.termId
        );
        this.universityGroups = !!result && result.success ? result.data : [];
        let currentGroup = null;
        if (this.universityGroups.length > 0) {
          currentGroup = this.universityGroups[0];
        }
        this.searchCondition.groupNumber = !!currentGroup
          ? currentGroup.GroupNumber
          : null;
      } catch (error) {
        console.error(error);
      }
    },
    async loadTrainingCategoryListFromServer() {
      if (
        this.searchCondition.courseType !==
        this.GLOBAL.courseType.vocationalTraining
      )
        return;

      try {
        let result = await getTrainingCategoryList(
          this.GLOBAL.courseType.vocationalTraining
        );
        this.trainingCourseCategories =
          !!result && result.success ? result.data : [];
        let currentCategory = null;
        if (this.trainingCourseCategories.length > 0) {
          currentCategory = this.trainingCourseCategories[0];
        }
        this.searchCondition.trainingCourseCategory = !!currentCategory
          ? currentCategory.Id
          : null;
      } catch (error) {
        console.error(error);
      }
    },
    async loadTrainingTermsFromServer() {
      if (
        this.searchCondition.courseType !==
        this.GLOBAL.courseType.vocationalTraining
      )
        return;

      try {
        let result = await getTrainingTerms(
          false,
          this.searchCondition.trainingCourseCategory
        );
        this.trainingTermList = !!result && result.success ? result.data : [];

        let currentTerm = null;
        if (this.trainingTermList.length > 0) {
          currentTerm = this.trainingTermList.find((i) => i.IsCurrentTerm);
          if (!currentTerm) currentTerm = this.trainingTermList[0];
        }
        this.searchCondition.trainingTermId = !!currentTerm
          ? currentTerm.Id
          : null;
      } catch (error) {
        console.error(error);
      }
    },
    async loadTermTeachersFromServer() {
      let termId =
        this.searchCondition.courseType !==
        this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.termId
          : this.searchCondition.trainingTermId;

      let groupNumber =
        this.searchCondition.courseType !==
        this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.groupNumber
          : null;

      let result = await getTermTeachers(termId, groupNumber);
      let termTeacherList = !!result && result.success ? result.data : [];
      if (this.USERMANAGER.isTeacher) {
        termTeacherList = termTeacherList.filter(
          (item) => item.Id === this.USERMANAGER.teacherId
        );
      }
      this.termTeacherList = termTeacherList;

      if (this.USERMANAGER.isTeacher) {
        this.searchCondition.teacherId = this.USERMANAGER.teacherId;
      } else {
        let currentTeacher = null;
        if (this.termTeacherList.length > 0) {
          currentTeacher = this.termTeacherList[0];
        }
        this.searchCondition.teacherId = !!currentTeacher
          ? currentTeacher.Id
          : 0;
      }
    },
    async loadCoursesInTermFromServer() {
      let courseType = this.searchCondition.courseType;
      let termId =
        courseType !== this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.termId
          : this.searchCondition.trainingTermId;
      let universityGroup =
        courseType !== this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.groupNumber
          : 0;

      try {
        let result = await getCoursesInTerm(
          termId,
          universityGroup,
          courseType
        );
        let courseList = !!result && result.success ? result.data : [];
        this.courseList = courseList;

        if (this.USERMANAGER.isTeacher) {
          this.$nextTick(() => {
            let currentCourse = null;
            if (this.filteredCourseList.length > 0) {
              currentCourse = this.filteredCourseList[0];
            }

            this.searchCondition.courseId = !!currentCourse
              ? currentCourse.Id
              : null;
            this.searchCondition.midtermExamDate = this.getMidtermExamDate();
          });
        } else {
          this.searchCondition.courseId = 0;
          this.searchCondition.midtermExamDate = null;
        }
        this.previousCourseId = this.searchCondition.courseId;
        this.searchCondition.isYearCourseMerged = this.showIsYearCourseMerged
          ? true
          : false;
      } catch (error) {
        console.error(error);
      }
    },
    async loadTermWeekListFromServer() {
      let termId =
        this.searchCondition.courseType !==
        this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.termId
          : this.searchCondition.trainingTermId;

      try {
        let result = await getWeekList(termId, false, true);
        this.weekList = !!result && result.success ? result.data : [];

        this.searchCondition.week = 0;
      } catch (error) {
        console.error(error);
      }
    },
    async loadCourseCampusListFromServer() {
      if (
        this.searchCondition.courseType !==
        this.GLOBAL.courseType.vocationalTraining
      )
        return;

      try {
        let result = await getCourseCampusList(this.searchCondition.courseId);
        this.courseCampusList = !!result && result.success ? result.data : [];

        this.searchCondition.campusId = 0;
      } catch (error) {
        console.error(error);
      }
    },
    async loadStudentScoreCollectionPageDataFromServer() {
      let courseType = this.searchCondition.courseType;
      let groupNumber =
        this.searchCondition.courseType !==
        this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.groupNumber
          : 0;
      let termId =
        courseType !== this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.termId
          : this.searchCondition.trainingTermId;
      let teacherId = this.searchCondition.teacherId;
      let courseId = this.searchCondition.courseId;

      //if (!courseType || !termId || (!teacherId && !courseId)) {
      if (!courseType || !termId) {
        this.signInListData = Object.clone(defaultValues.signInListData);
        this.originalSignInListData = Object.clone(this.signInListData);
        return;
      }
      if (!this.validateSearchDate()) {
        return;
      }

      let searchDate = this.getSearchDate();
      let isYearCourseMerged = false;
      //this.showIsYearCourseMerged && this.searchCondition.isYearCourseMerged;

      let examType =
        this.searchCondition.viewMode === 1 ? this.searchCondition.examType : 0;
      if (this.searchCondition.viewMode === 1) {
        this.paginationOption.showTotalMinutes = false;
        this.paginationOption.showSpecialCols = false;
        this.paginationOption.showMidtermCols =
          examType === enumExamType.Midterm;
        this.paginationOption.showTerminalCols =
          examType === enumExamType.Terminal;
        this.paginationOption.showRealAttendance = false;
      } else {
        this.paginationOption.showTotalMinutes = !this.USERMANAGER.isTeacher;
        this.paginationOption.showSpecialCols = true;
        this.paginationOption.showMidtermCols = true;
        this.paginationOption.showTerminalCols = true;
        this.paginationOption.showRealAttendance = !this.USERMANAGER.isTeacher;
      }
      
      this.loading = true;
      try {
        let result = await getStudentScoreCollectionPageData(
          courseType,
          groupNumber,
          termId,
          teacherId,
          courseId,
          this.searchCondition.trainingCourseCategory,
          this.searchCondition.campusId,
          this.searchCondition.week,
          searchDate,
          this.searchCondition.isVideoCourseRemoved,
          isYearCourseMerged
        );
        this.signInListData =
          !!result && result.success
            ? result.data
            : Object.clone(defaultValues.signInListData);
        this.originalSignInListData = Object.clone(this.signInListData);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async saveStudentSpeedupCoursesScoreToServer() {
      let changedScoreDataList = this.getChangedScoreDataList(true);
      if (!changedScoreDataList){
        return false;
      }
      if (changedScoreDataList.length === 0) {
        this.$message.info("未修改成绩，无需保存");
        return false;
      }

      try {
        let result = await saveStudentSpeedupCoursesScore(changedScoreDataList);

        if (!result || !result.success) {
          this.$message.error(`成绩修改失败。${result.message}`);
          return false;
        }

        this.$message.success("成绩修改成功");
        this.originalSignInListData = Object.clone(this.signInListData);
        return true;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    loadCourseTypeItems() {
      let exceptCourseTypes = [
        this.GLOBAL.courseType.none,
        this.GLOBAL.courseType.english,
        this.GLOBAL.courseType.newStudentGuide,
        this.GLOBAL.courseType.vocationalTraining,
      ];
      let courseTypeItems = Object.clone(this.GLOBAL.courseType.getOptions());
      courseTypeItems = courseTypeItems.filter(
        (item) => !exceptCourseTypes.contains(item.value)
      );
      this.courseTypeItems = courseTypeItems;
      let currentCourseTypeItem =
        courseTypeItems.length > 0 ? courseTypeItems[0] : null;
      this.searchCondition.courseType = !!currentCourseTypeItem
        ? currentCourseTypeItem.value
        : null;
    },
    getSearchDate() {
      let date = "";
      if (this.searchCondition.searchDate) {
        date = formatDate(this.searchCondition.searchDate);
      }
      return date;
    },
    validateSearchDate() {
      if (this.searchCondition.week && this.searchCondition.searchDate) {
        let weekItem = this.weekList.find(
          (i) => i.Week == this.searchCondition.week
        );
        if (weekItem) {
          let startDate = new Date(weekItem.StartDate);
          let endDate = new Date(weekItem.EndDate);
          if (
            this.searchCondition.searchDate < startDate ||
            this.searchCondition.searchDate > endDate
          ) {
            let searchDate = this.getSearchDate();
            let msg = `结束日期${searchDate}需要在当前选择周${weekItem.Label}的日期范围内`;
            this.$message.error(msg);
            return false;
          }
        }
      }
      return true;
    },
    async reloadSearchConditionsAndListData() {
      this.searchCondition.viewMode = this.isDesktop() ? 0 : 1;
      this.loading = true;
      this.loadCourseTypeItems();

      await this.loadScoreListFromServer();
      await this.loadTermsFromServer();
      await this.loadUniversityScoreLocksFromServer();
      await this.loadUniversityGroupsFromServer();
      await this.loadTrainingCategoryListFromServer();
      await this.loadTrainingTermsFromServer();
      await this.loadTermTeachersFromServer();
      await this.loadCoursesInTermFromServer();
      await this.loadTermWeekListFromServer();
      await this.loadCourseCampusListFromServer();
      await this.loadStudentScoreCollectionPageDataFromServer();

      this.checkLocked();
      this.isConditionChange = false;
      this.loading = false;
    },
    onCourseTypeChange() {
      this.$nextTick(async () => {
        this.isConditionChange = true;
        this.isConditionLoading = true;
        await this.loadTrainingCategoryListFromServer();
        await this.loadTrainingTermsFromServer();
        await this.loadTermTeachersFromServer();
        await this.loadCoursesInTermFromServer();
        await this.loadCourseCampusListFromServer();
        await this.loadTermWeekListFromServer();
        this.isConditionLoading = false;
      });
    },
    onTermIdChange() {
      this.$nextTick(async () => {
        this.isConditionChange = true;
        this.isConditionLoading = true;
        await this.loadUniversityScoreLocksFromServer();
        await this.loadUniversityGroupsFromServer();
        await this.loadTermTeachersFromServer();
        await this.loadCoursesInTermFromServer();
        await this.loadTermWeekListFromServer();
        this.isConditionLoading = false;
      });
    },
    onGroupNumberChange() {
      this.$nextTick(async () => {
        this.isConditionChange = true;
        this.isConditionLoading = true;
        await this.loadTermTeachersFromServer();
        await this.loadCoursesInTermFromServer();
        this.isConditionLoading = false;
      });
    },
    onTrainingCourseCategoryChange() {
      this.$nextTick(async () => {
        this.isConditionChange = true;
        this.isConditionLoading = true;
        await this.loadTrainingTermsFromServer();
        await this.loadTermTeachersFromServer();
        await this.loadCoursesInTermFromServer();
        await this.loadTermWeekListFromServer();
        this.isConditionLoading = false;
      });
    },
    onTrainingTermIdChange() {
      this.$nextTick(async () => {
        this.isConditionChange = true;
        this.isConditionLoading = true;
        await this.loadTermTeachersFromServer();
        await this.loadCoursesInTermFromServer();
        await this.loadTermWeekListFromServer();
        this.isConditionLoading = false;
      });
    },
    onTeacherIdChange() {
      if (!this.searchCondition.teacherId) {
        if (!!this.searchCondition.courseId) return;

        let firstCourse =
          this.filteredCourseList.length > 0
            ? this.filteredCourseList[0]
            : null;
        if (!!firstCourse) {
          this.searchCondition.courseId = firstCourse.Id;
          return;
        }
      }

      this.searchCondition.courseId = 0;
      this.previousCourseId = this.searchCondition.courseId;
    },
    onCourseIdChange() {
      this.previousCourseId = this.searchCondition.courseId;
  
      this.$nextTick(async () => {
        await this.loadCourseCampusListFromServer();

        this.searchCondition.isYearCourseMerged = this.showIsYearCourseMerged;
      });
      this.isConditionChange = true;
    },
    onIsVideoCourseRemovedChange() {},
    onWeekChange() {},
    onCampusIdChange() {},
    onIsYearCourseMergedChange() {},
    onExamTypeChange() {
      let examType =
        this.searchCondition.viewMode === 1 ? this.searchCondition.examType : 0;
      if (this.searchCondition.viewMode === 1) {
        this.paginationOption.showMidtermCols =
          examType === enumExamType.Midterm;
        this.paginationOption.showTerminalCols =
          examType === enumExamType.Terminal;

        this.onSearch(this.searchCondition.viewMode);
      }
    },
    onSearch(viewMode = 0) {
      this.searchCondition.viewMode = viewMode;
      this.loadStudentScoreCollectionPageDataFromServer();
      this.checkLocked();
      this.isConditionChange = false;
    },
    onSave() {
      this.$nextTick(async () => {
        let result = await this.saveStudentSpeedupCoursesScoreToServer();
        if (result) {
          this.loadStudentScoreCollectionPageDataFromServer();
          this.isScoreEditing = false;
        }
      });
    },
    onCancel() {
      this.checkAndSaveDataChanges(this.cancelChanges, () => {
        this.loadStudentScoreCollectionPageDataFromServer();
        this.isScoreEditing = false;
      });
    },
    cancelChanges(){
      this.signInListData = Object.clone(this.originalSignInListData);
      this.searchCondition.midtermExamDate = null;
      this.searchCondition.midtermAverageScore = null;
      this.isScoreEditing = false;
    },
    onEdit() {
      this.isScoreEditing = true;
    },
    onMidtermExamDateSave() {
      let dateVal = this.searchCondition.midtermExamDate;
      let dateStr = dateVal ? (typeof dateVal === "string" ? dateVal : moment(dateVal).format("YYYY-MM-DD")) : null;
      this.signInListData.Results.forEach((item) => {
        item.MidtermExamDate = dateStr;
      });
    },
    onMidtermAverageScoreSave() {
      this.signInListData.Results.forEach((item) => {
        item.MidtermAverageScore = this.searchCondition.midtermAverageScore;
      });
    },
    getExportSearchParams() {
      let courseType = this.searchCondition.courseType;
      let groupNumber =
        this.searchCondition.courseType !==
        this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.groupNumber
          : 0;
      let termId =
        courseType !== this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.termId
          : this.searchCondition.trainingTermId;
      let teacherId = this.searchCondition.teacherId;
      let courseId = this.searchCondition.courseId;

      return {
        courseType,
        groupNumber,
        termId,
        teacherId,
        courseId,
        trainingCourseCategory: this.searchCondition.trainingCourseCategory,
        campusId: this.searchCondition.campusId,
      };
    },
    async onExport() {
      let params = this.getExportSearchParams();

      this.isExporting = true;
      try {
        let result = await exportStudentScore(
          params.courseType,
          params.groupNumber,
          params.termId,
          params.teacherId,
          params.courseId,
          params.trainingCourseCategory,
          params.campusId
        );
        if (!!result && result.success) {
          downloadFile(result);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isExporting = false;
      }
    },
    async onDownloadScoreAttachments() {
      let params = this.getExportSearchParams();

      this.isDownloadingAttachments = true;
      try {
        let result = await downloadStudentScoreAttachments(
          params.courseType,
          params.groupNumber,
          params.termId,
          params.teacherId,
          params.courseId,
          params.trainingCourseCategory,
          params.campusId
        );
        if (!!result && result.success) {
          downloadFile(result);
        } else if (result && result.message) {
          this.$message.error(result.message);
        }
      } catch (error) {
        console.error(error);
        if (error && error.message) {
          this.$message.error(error.message);
        }
      } finally {
        this.isDownloadingAttachments = false;
      }
    },
    checkLocked() {
      let item = this.scoreLocks.find(
        (i) => i.UniversityGroup === this.searchCondition.groupNumber
      );
      if (item) {
        this.isLocked = item.IsLocked;
      } else {
        this.isLocked = true;
      }
      this.showLockedLabel = true;
    },
    haveScoreDataChanges() {
      let dataList = this.getChangedScoreDataList();
      console.log("dataList", dataList);
      return dataList && dataList.length > 0;
    },
    checkAndSaveDataChanges(next, afterSave){
      if (this.haveScoreDataChanges()) {
        this.$confirm("成绩设置已修改，是否保存?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            let result = await this.saveStudentSpeedupCoursesScoreToServer();
            if (result) {
              afterSave();
            }
          })
          .catch(() => {
            next();
          });
      } else {
        next();
      }
    }
  },
  async beforeRouteLeave(to, from, next) {
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.
    this.checkAndSaveDataChanges(next, next);
  },
};
</script>

<style lang="scss" scoped>
/deep/ body .el-table .el-table-header th {
  height: 30px;
  padding: 5px 0px;
  color: #909399 !important;
  background-color: #fff !important;
}

.cs-contentContainer {
  .grid-content {
    margin-top: 15px;
    /deep/ .el-table .el-table-header th {
      height: 30px;
      padding: 5px 0px;
      color: #909399 !important;
      background-color: #fff !important;
    }
  }
}

.cs-titleContainer {
  .cs-title {
    @media only screen and (max-width: 767px),
      only screen and (max-height: 767px) and (max-width: 1364px) {
      font-size: 18px;
    }
  }
}

.cs-search-conditions {
  .el-col {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .el-select,
  .el-input {
    width: 100%;
  }

  .cs-buttons {
    text-align: right;

    .el-button {
      margin-top: 2px;
      margin-bottom: 2px;
    }
  }

  .cs-isVideoCourseRemoved,
  .cs-isYearCourseMerged {
    line-height: 36px;
    margin-bottom: 0;
    margin-left: 5px;
  }

  .cs-editor {
    &.right {
      text-align: right;
    }

    .el-input {
      max-width: 145px;
    }
  }

  .cs-empty {
    height: 0;
  }

  .el-button {
    margin-top: 2px;
    margin-bottom: 2px;
  }

  .shown-xs-only {
    span {
      font-size: 12px;
    }

    .cs-editor {
      .el-input {
        max-width: 125px;
      }
    }
  }
}

.cs-table {
  .el-input,
  .el-select {
    width: 100%;
  }

  .el-button + .el-button {
    margin-left: 0;
  }

  /deep/ table {
    @media only screen and (max-width: 767px),
      only screen and (max-height: 767px) and (max-width: 1364px) {
      th,
      tr {
        font-size: 12px;
      }

      .hidden-xs-only {
        display: none !important;

        &.shown-midterm,
        &.shown-terminal {
          display: table-cell !important;
        }
      }
    }
  }
}

.cs-studentScoreCollection-editor-item{
  display: inline-block;
  margin-right: 20px;
  &:last-of-type{
    margin-right: 0;
  }
}

.cs-studentScoreCollection-info{
  margin-top: 10px;
  span{
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/admin/studentScoreCollection.vue